






















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
interface IBarchartDatas {
  value: number;
  labelText: string;
  labelIcon: string;
  labelColor: string;
  stageBack: string;
  description: string;
}

@Component
export default class iBarchart extends Vue {
  @Prop({
    required: true,
    default: null
  })
  datas!: IBarchartDatas[] | null;

  @Prop({
    required: true,
    type: Number
  })
  max!: number;

  @Prop({
    required: true,
    type: Boolean
  })
  play!: boolean;

  private asyncDatas = [];
  private isInited = false;

  private _data: IBarchartDatas[] = [];

  @Watch("play")
  handleDatasChange(val: boolean) {
    if (val && this.isInited === false) {
      this.init();
    }
  }

  init() {
    if (this.datas !== null && this.isInited === false) {
      this.isInited = true;
      let values: number[] = [];
      this.datas.forEach(el => {
        values.push(el.value);
        el.value = 0;
      });
      this._data = this.datas;
      setTimeout(() => {
        if (this.datas !== null) {
          this.datas.forEach((el, idx) => {
            el.value = values[idx];
          });
          this._data = this.datas;
        }
      }, 1000);
    }
  }
  //   private datas =
}
